/**
 * @GENERATED from Figma node 3638:52290
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const FontDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#978F86"
      d="M6.166 4 1 20h1.948l1.59-4.924h6.02L12.149 20h1.947L8.93 4zm-1.032 9.23 2.414-7.479 2.414 7.48zM21.146 12v1.086A2.4 2.4 0 0 0 18.983 12c-2.516 0-4.018 1.495-4.018 4s1.502 4 4.018 4a2.34 2.34 0 0 0 2.163-1.334v1.333H23v-8zm-2.163 6.153c-1.496 0-2.164-.664-2.164-2.153 0-1.49.668-2.154 2.164-2.154s2.163.664 2.163 2.153c0 1.49-.668 2.154-2.163 2.154"
    />
  </svg>
);
const ForwardRef = React.forwardRef(FontDark);
export { ForwardRef as FontDark };
